module.exports = __webpack_public_path__ + "img/3.055db082.png";